<template>
    <main
        id="content"
        class="content-default promotion-content result-content relative-section"
    >
        <div class="container">
            <div class="relative-section">
                <div class="primary-main">
                    <div class="relative-section">
                        <div class="brecrump font-bai">
                            <router-link to="/">
                                {{ $t("app.Home") }} </router-link
                            >/
                            <b>{{ $t("app.vente flash") }}</b>
                        </div>
                        <h2
                            class="relative-section text-center section-title font-balo"
                        >
                            <span class="font-bold">
                                {{ $t("app.vente flash") }}
                            </span>
                        </h2>
                        <div
                            class="nodata text-center"
                            v-if="promotions.length === 0"
                        >
                            <img src="../assets/images/notfound.png" alt />
                            <br />
                            <a
                                href
                                @click.prevent="onGotoSearch()"
                                class="btn font-balo"
                            >
                                {{ $t("app.Voir nos offres disponibles") }}
                            </a>
                        </div>
                        <div class="layout-view">
                            <a
                                href="#grid-view"
                                class="grid-view"
                                v-bind:class="{ active: viewing === 'grid' }"
                                @click.prevent="changeViewing('grid')"
                            ></a>
                            <a
                                href="#list-view"
                                v-bind:class="{ active: viewing === 'list' }"
                                class="list-view"
                                @click.prevent="changeViewing('list')"
                            ></a>
                        </div>
                        <div
                            v-for="(promotion, index) in promotions"
                            :key="index"
                        >
                            <h2 class="title-promotion-time">
                                {{ getPromotionTime(promotion) }}
                            </h2>
                            <ul
                                id="grid-view"
                                class="product-view product-list product-list-search slider-call slider-default row"
                                v-bind:class="{ active: viewing === 'grid' }"
                            >
                                <li
                                    class="col-sm-4"
                                    v-for="(room, index) in promotion.reference"
                                    :key="index"
                                >
                                    <RoomGridPromotionItem
                                        :room="room"
                                        :filter="filter"
                                        :promotion="promotion"
                                    />
                                </li>
                            </ul>
                            <ul
                                id="list-view"
                                class="product-view product-list product-list-search"
                                v-bind:class="{ active: viewing === 'list' }"
                            >
                                <li
                                    v-for="(room, index) in promotion.reference"
                                    :key="index"
                                >
                                    <RoomListPromotionItem
                                        :room="room"
                                        :filter="filter"
                                        :promotion="promotion"
                                    />
                                </li>
                            </ul>
                        </div>

                        <BackToTop />
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import RoomGridPromotionItem from "@/components/RoomGridPromotionItem";
import RoomListPromotionItem from "@/components/RoomListPromotionItem";
import { ADULT_COUNT_DEFAULT } from "@/api/config";
import BackToTop from "@/components/BackToTop";
import { get, first } from "lodash";
import moment from "moment";
import { setDescriptionPage } from "@/helper/helper";
import { formatBookDate } from "@/helper/calculateDays";
export default {
    name: "PromotionPage",
    data() {
        return {
            viewing: "grid"
        };
    },
    components: {
        RoomGridPromotionItem,
        RoomListPromotionItem,
        BackToTop
    },
    mounted() {
        this.getPromotions();
        setDescriptionPage(get(this.general, "flash_page_metades"));
    },
    computed: {
        ...mapState({
            general: state => get(state, "app.general", {}),
            promotions: state => get(state, "hotels.promotions", []),
            filter: state => get(state, "hotels.filter", {}),
            campingClubs: state => get(state, "campingClubs.list", [])
        })
    },
    methods: {
        ...mapMutations("hotels", ["setFilter"]),
        ...mapActions("hotels", ["getPromotions"]),
        changeViewing(viewing) {
            this.viewing = viewing;
        },
        getPromotionTime(promotion) {
            return `${this.$i18n.t("app.Du")} ${moment(
                promotion.start_date,
                "DD-MM-YYYY"
            ).format("DD/MM/YYYY")} ${this.$i18n.t("app.au")} ${moment(
                promotion.end_date,
                "DD-MM-YYYY"
            ).format("DD/MM/YYYY")}`;
        },
        onGotoSearch() {
            const camping = first(this.campingClubs);
            let dataReferences = {
                camping: camping ? camping.id : null,
                dateFrom: formatBookDate(moment()),
                dateTo: formatBookDate(moment().add(2, "days")),
                type: null,
                adult: ADULT_COUNT_DEFAULT,
                child: 0,
                child1: 0
            };
            this.setFilter(dataReferences);
            this.$router.push("/result");
        }
    }
};
</script>
